import { render, staticRenderFns } from "./CoinNetworkCharges.vue?vue&type=template&id=7fd116b0&scoped=true&"
import script from "./CoinNetworkCharges.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkCharges.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkCharges.vue?vue&type=style&index=0&id=7fd116b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd116b0",
  null
  
)

export default component.exports